
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1394_20417)","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M3 10h14M10 3v14"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1394_20417"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(2 2)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    